__turbopack_context__.v({
  "content": "index-module__fZCK5a__content",
  "header": "index-module__fZCK5a__header",
  "root": "index-module__fZCK5a__root",
});
